import { lazy, ComponentType, LazyExoticComponent } from "react";

export function lazyNamed<
    T extends Record<string, ComponentType<any>>,
    K extends keyof T
>(
    factory: () => Promise<T>,
    name: K
): LazyExoticComponent<T[K]> {
    return lazy(() =>
        factory().then((module) => ({
            default: module[name],
        }))
    );
}